import images from "@/assets/images";
import Constants from "@/constants";
import { clickGeneralDownload } from "@/report";
import { downloadFile } from "@/utils";
import React from "react";

interface IIOSAndHDProps {
  next: () => void;
}
const IOSAndHD: React.FC<IIOSAndHDProps> = ({ next }) => {
  return (
    <div className="hide-scroll-bar flex max-h-full flex-col items-center overflow-y-auto px-[25px] pb-[30px] pt-[64px]">
      <img src={images.PC2} className="mb-[52px] w-[92%]" />
      <p className="mb-[8px] text-[16px] leading-[22px] text-[#fff]">虎牙直播移动端</p>
      <p className="mb-[20px] text-[32px] leading-[45px] text-[#fff]">蓝光直播赛事随时看</p>
      {/* <p className="mb-[20px] text-[12px] leading-[22px] text-[#FFFFFF99]">V12.7.70｜2025/08/27</p> */}
      <PopoverContent />
      <img src={images.iconDown1} className="mt-[55px] h-[24px] w-[24px]" onClick={next} />
    </div>
  );
};

const PopoverContent = () => {
  return (
    <div className="flex h-[142px] w-[340px] rounded-[4px] bg-[#292929] p-[16px]">
      <img src={images.qrcode} className="mr-[12px] h-[110px] w-[110px]" />
      <div className="flex flex-1 flex-col justify-between">
        <div>
          <p className="text-[14px] font-[500] leading-[20px] text-[#fff]">手机或平板扫码下载</p>
          <p className="mt-[8px] text-[12px] font-[500] leading-[17px] text-[#FFFFFF99]">
            或手动下载安装包
          </p>
        </div>
        <div className="flex w-full items-center justify-between">
          <div
            className="flex"
            onClick={() => {
              downloadFile(Constants.DOWNLOAD_URL.APP_IOS);
              clickGeneralDownload({
                button_name: "iOS安装包",
                product_name: "1",
              });
            }}
          >
            <img src={images.iconDown} className="mr-[4px] h-[16px] w-[16px]" />
            <p className="text-[13px] leading-[18px] text-[#ffe44d]">iOS安装包</p>
          </div>
          <div
            className="flex"
            onClick={() => {
              downloadFile(Constants.DOWNLOAD_URL.APP_ADR);
              clickGeneralDownload({
                button_name: "安卓安装包",
                product_name: "1",
              });
            }}
          >
            <img src={images.iconDown} className="mr-[4px] h-[16px] w-[16px]" />
            <p className="text-[13px] leading-[18px] text-[#ffe44d]">安卓安装包</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IOSAndHD;
